import React from 'react';
const SvgProcessSuspendThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg width="1em" height="1em" viewBox="0 0 90 102" {...props}>
      <defs>
        <path
          d="M25.445 67.8L19.8 71.06l2.19-12.177 11.45 4.301-5.233 3.022c3.467 4.18 8.7 6.844 14.556 6.844 3.846 0 7.424-1.149 10.409-3.122l1.736 2.63A21.947 21.947 0 0142.763 76.2c-7.023 0-13.28-3.284-17.318-8.4zm37.8-5.467l5.632 3.252-11.64 4.19-2-12.065 5.247 3.028a18.86 18.86 0 001.18-6.588c0-7.4-4.252-13.805-10.446-16.908l1.409-2.818c7.226 3.62 12.186 11.094 12.186 19.726a21.99 21.99 0 01-1.568 8.183zm-23.632-30.01V25.8l9.45 7.985-9.45 7.765v-6.039c-8.938 1.5-15.75 9.274-15.75 18.639 0 .381.012.76.034 1.136l-3.144.188c-.026-.438-.04-.88-.04-1.324 0-11.108 8.215-20.298 18.9-21.827z"
          id="process-suspend-thumbnail_svg__a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path fill="#CCC" fillRule="nonzero" d="M.9.6v100.8h88.2V25.8H63.9V.6z" />
        <path fill="#666" fillRule="nonzero" opacity={0.3} d="M89.1 44.7L63.9 25.8h25.2z" />
        <path fill="#ECECEC" fillRule="nonzero" d="M63.9.6l25.2 25.2H63.9z" />
        <use fill="#FFF" xlinkHref="#process-suspend-thumbnail_svg__a" />
      </g>
    </svg>
  );
});
export default SvgProcessSuspendThumbnail;
SvgProcessSuspendThumbnail.iconName = 'process-suspend-thumbnail';
SvgProcessSuspendThumbnail.displayName = 'SvgProcessSuspendThumbnail';
